export const groubBySeparator = (string, separator) => string.split(separator);

